import { createContext } from 'react';
// import Plausible from 'plausible-tracker';

import { TrackingEvent } from './Tracking.events';
import Matomo from '@canvasflow/analytics/src/tracker/tracker';

export const LOCATION_CHANNEL_KEY = 'location';

export const TrackingContext = createContext<ContextProps>({
	gtag: null,
	gtm: null,
	metaPixel: null,
	locationChannel: new BroadcastChannel(LOCATION_CHANNEL_KEY),
	matomo: null,
	sendEvent: () => {},
});

interface ContextProps {
	gtag?: any;
	gtm?: any;
	plausible?: any;
	location?: Location;
	locationChannel: BroadcastChannel;
	metaPixel?: any;
	matomo?: Matomo | null;
	sendEvent: (event: TrackingEvent) => void;
}
